import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Container, Card, Table, Button, Row, Col, Modal, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { FaTrash, FaPlus, FaSortUp, FaSortDown, FaSort } from 'react-icons/fa';
import moment from 'moment';
import Header from '~/Components/Header/Header';
import Loading from '~/Components/Loading';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import * as api from '~/Services/Service';

var OPCOES_POR_PAGINA = [
  { value: 20, label: '20' },
  { value: 50, label: '50' },
  { value: 0, label: 'Todos' },
];

var RestringirAcesso = function () {
  var _useState = function (val) { return useState(val); };

  var vinculosState = _useState([]);
  var vinculos = vinculosState[0]; var setVinculos = vinculosState[1];
  var loadingState = _useState(false);
  var loading = loadingState[0]; var setLoading = loadingState[1];
  var filtroUsuarioState = _useState(null);
  var filtroUsuario = filtroUsuarioState[0]; var setFiltroUsuario = filtroUsuarioState[1];
  var usuariosState = _useState([]);
  var usuarios = usuariosState[0]; var setUsuarios = usuariosState[1];
  var usuarioInclusaoState = _useState(null);
  var usuarioInclusao = usuarioInclusaoState[0]; var setUsuarioInclusao = usuarioInclusaoState[1];
  var empreendimentoInclusaoState = _useState(null);
  var empreendimentoInclusao = empreendimentoInclusaoState[0]; var setEmpreendimentoInclusao = empreendimentoInclusaoState[1];
  var incluindoState = _useState(false);
  var incluindo = incluindoState[0]; var setIncluindo = incluindoState[1];
  var ordenacaoState = _useState({ campo: 'nome_usuario', direcao: 'asc' });
  var ordenacao = ordenacaoState[0]; var setOrdenacao = ordenacaoState[1];
  var confirmacaoState = _useState({ show: false, codigo: null });
  var confirmacao = confirmacaoState[0]; var setConfirmacao = confirmacaoState[1];
  var porPaginaState = _useState(20);
  var porPagina = porPaginaState[0]; var setPorPagina = porPaginaState[1];
  var paginaAtualState = _useState(1);
  var paginaAtual = paginaAtualState[0]; var setPaginaAtual = paginaAtualState[1];

  var empreendimentos = useSelector(function (state) { return state.empreendimentos; });

  var empreendimentosOptions = (empreendimentos && empreendimentos.sort ? empreendimentos.sort : []).map(function (e) {
    return { value: e.codigo, label: e.codigo + ' - ' + e.descricao };
  });

  useEffect(function () {
    carregarUsuarios();
    carregarVinculos(null);
  }, []);

  var carregarUsuarios = async function () {
    try {
      var res = await api.buscarUsuarioOptions('ativos');
      setUsuarios(
        (res || []).map(function (u) {
          return {
            value: u.codigo_usuario,
            label: u.codigo_usuario + ' - ' + (u.nome_completo || u.nome || ''),
          };
        })
      );
    } catch (e) {
      toast.error('Erro ao carregar usuários');
    }
  };

  var carregarVinculos = async function (codigoUsuario) {
    setLoading(true);
    try {
      var res = await api.listarUsuarioFamilia(codigoUsuario);
      setVinculos(res || []);
    } catch (e) {
      toast.error('Erro ao carregar vínculos');
    } finally {
      setLoading(false);
    }
  };

  var handleFiltroChange = function (opcao) {
    setFiltroUsuario(opcao);
    setPaginaAtual(1);
    carregarVinculos(opcao ? opcao.value : null);
  };

  var handleIncluir = async function () {
    if (!usuarioInclusao) {
      toast.warning('Informe um usuário');
      return;
    }
    if (!empreendimentoInclusao) {
      toast.warning('Informe um empreendimento');
      return;
    }
    setIncluindo(true);
    try {
      await api.incluirUsuarioFamilia({
        codigo_usuario: usuarioInclusao.value,
        codigo_familia: empreendimentoInclusao.value,
      });
      toast.success('Vínculo incluído');
      setUsuarioInclusao(null);
      setEmpreendimentoInclusao(null);
      carregarVinculos(filtroUsuario ? filtroUsuario.value : null);
    } catch (err) {
      var msg = (err && err.response && err.response.data && err.response.data.message) || 'Erro ao incluir vínculo';
      toast.warning(msg);
    } finally {
      setIncluindo(false);
    }
  };

  var handleExcluirClick = function (codigo) {
    setConfirmacao({ show: true, codigo: codigo });
  };

  var handleConfirmarExclusao = async function (confirmado) {
    var codigo = confirmacao.codigo;
    setConfirmacao({ show: false, codigo: null });
    if (!confirmado) return;
    try {
      await api.excluirUsuarioFamilia({ codigo: codigo });
      toast.success('Vínculo excluído');
      carregarVinculos(filtroUsuario ? filtroUsuario.value : null);
    } catch (err) {
      toast.error('Erro ao excluir vínculo');
    }
  };

  var handleOrdenacao = function (campo) {
    setOrdenacao(function (prev) {
      if (prev.campo === campo) {
        return { campo: campo, direcao: prev.direcao === 'asc' ? 'desc' : 'asc' };
      }
      return { campo: campo, direcao: 'asc' };
    });
  };

  var iconeOrdenacao = function (campo) {
    if (ordenacao.campo !== campo) return <FaSort style={{ opacity: 0.3, marginLeft: 4 }} />;
    return ordenacao.direcao === 'asc'
      ? <FaSortUp style={{ marginLeft: 4 }} />
      : <FaSortDown style={{ marginLeft: 4 }} />;
  };

  var thSortStyle = { cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' };

  var vinculosOrdenados = vinculos.slice().sort(function (a, b) {
    var campo = ordenacao.campo;
    var dir = ordenacao.direcao === 'asc' ? 1 : -1;
    var valA = a[campo] != null ? a[campo] : '';
    var valB = b[campo] != null ? b[campo] : '';
    if (typeof valA === 'string') {
      return dir * valA.toLowerCase().localeCompare(String(valB).toLowerCase());
    }
    return dir * (valA - valB);
  });

  var totalRegistros = vinculosOrdenados.length;
  var totalPaginas = porPagina === 0 ? 1 : Math.ceil(totalRegistros / porPagina);
  var vinculosPaginados = porPagina === 0
    ? vinculosOrdenados
    : vinculosOrdenados.slice((paginaAtual - 1) * porPagina, paginaAtual * porPagina);

  var handlePorPaginaChange = function (valor) {
    setPorPagina(Number(valor));
    setPaginaAtual(1);
  };

  var gerarNumerosPaginas = function () {
    var paginas = [];
    for (var i = 1; i <= totalPaginas; i++) { paginas.push(i); }
    return paginas;
  };

  return (
    <Container fluid className="px-3 py-3">
      <style>{'\
        .restringir-desktop { display: block; }\
        .restringir-mobile  { display: none; }\
        @media (max-width: 768px) {\
          .restringir-desktop { display: none !important; }\
          .restringir-mobile  { display: block; }\
        }\
      '}</style>

      <Header title="Restringir Empreendimentos" />

      {/* Card Filtro + Inclusão unificados */}
      <Card className="shadow-sm mb-3">
        <Card.Body className="py-2">
          <Row className="align-items-end">
            <Col md={3} className="mb-2 mb-md-0">
              <small className="text-muted d-block mb-1">Filtrar por Usuário</small>
              <Select
                placeholder="Todos os usuários..."
                options={usuarios}
                value={filtroUsuario}
                onChange={handleFiltroChange}
                isClearable
                components={{ DropdownIndicator }}
                styles={customStyles}
              />
            </Col>
            <Col md={3} className="mb-2 mb-md-0">
              <small className="text-muted d-block mb-1">Usuário</small>
              <Select
                placeholder="Selecione um usuário..."
                options={usuarios}
                value={usuarioInclusao}
                onChange={setUsuarioInclusao}
                isClearable
                components={{ DropdownIndicator }}
                styles={customStyles}
              />
            </Col>
            <Col md={3} className="mb-2 mb-md-0">
              <small className="text-muted d-block mb-1">Empreendimento</small>
              <Select
                placeholder="Selecione um empreendimento..."
                options={empreendimentosOptions}
                value={empreendimentoInclusao}
                onChange={setEmpreendimentoInclusao}
                isClearable
                components={{ DropdownIndicator }}
                styles={customStyles}
              />
            </Col>
            <Col md={3} className="mb-2 mb-md-0">
              <small className="text-muted d-block mb-1">&nbsp;</small>
              <Button
                variant="primary"
                onClick={handleIncluir}
                disabled={incluindo}
                style={{ height: 38, width: '100%' }}
              >
                <FaPlus className="mr-1" />
                {incluindo ? 'Incluindo...' : 'Incluir'}
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Card Grid */}
      <Card className="shadow-sm">
        <Card.Header
          className="d-flex justify-content-between align-items-center py-2"
          style={{ backgroundColor: '#0747a6', color: '#fff' }}
        >
          <strong>
            Vínculos
            <span className="ml-2" style={{ fontSize: '0.85rem', opacity: 0.8 }}>
              ({totalRegistros} {totalRegistros === 1 ? 'registro' : 'registros'})
            </span>
          </strong>
          <div className="d-flex align-items-center">
            <small className="mr-2">Exibir:</small>
            <Form.Control
              as="select"
              size="sm"
              value={porPagina}
              onChange={function (e) { handlePorPaginaChange(e.target.value); }}
              style={{ width: 'auto', backgroundColor: 'transparent', color: '#fff', border: '1px solid rgba(255,255,255,0.5)' }}
            >
              {OPCOES_POR_PAGINA.map(function (op) {
                return <option key={op.value} value={op.value} style={{ color: '#333' }}>{op.label}</option>;
              })}
            </Form.Control>
          </div>
        </Card.Header>
        <Card.Body className="p-0">
          {loading ? (
            <Loading />
          ) : vinculosOrdenados.length === 0 ? (
            <p className="text-muted text-center my-4">Nenhum vínculo encontrado.</p>
          ) : (
            <>
              {/* Desktop */}
              <div className="restringir-desktop">
                <Table striped bordered hover size="sm" className="mb-0">
                  <thead>
                    <tr>
                      <th style={Object.assign({}, thSortStyle)} onClick={function () { handleOrdenacao('nome_empreendimento'); }}>
                        Empreendimento{iconeOrdenacao('nome_empreendimento')}
                      </th>
                      <th style={Object.assign({}, thSortStyle)} onClick={function () { handleOrdenacao('nome_usuario'); }}>
                        Usuário{iconeOrdenacao('nome_usuario')}
                      </th>
                      <th style={Object.assign({}, thSortStyle)} onClick={function () { handleOrdenacao('incluido_por'); }}>
                        Incluído por{iconeOrdenacao('incluido_por')}
                      </th>
                      <th style={Object.assign({ width: '140px' }, thSortStyle)} onClick={function () { handleOrdenacao('data_inclusao'); }}>
                        Data Inclusão{iconeOrdenacao('data_inclusao')}
                      </th>
                      <th style={{ width: '60px', textAlign: 'center' }}>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vinculosPaginados.map(function (item) {
                      return (
                        <tr key={item.codigo}>
                          <td>{item.codigo_familia + ' - ' + item.nome_empreendimento}</td>
                          <td>{item.nome_usuario}</td>
                          <td>{item.incluido_por}</td>
                          <td>{item.data_inclusao ? moment(item.data_inclusao).format('DD/MM/YYYY HH:mm') : '-'}</td>
                          <td className="text-center">
                            <Button
                              size="sm"
                              variant="outline-danger"
                              title="Excluir"
                              onClick={function () { handleExcluirClick(item.codigo); }}
                            >
                              <FaTrash />
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>

              {/* Mobile */}
              <div className="restringir-mobile p-2">
                {vinculosPaginados.map(function (item) {
                  return (
                    <Card key={item.codigo} className="mb-2 shadow-sm">
                      <Card.Body className="py-2 px-3">
                        <div className="d-flex justify-content-between align-items-start mb-1">
                          <div>
                            <strong style={{ fontSize: '0.95rem' }}>{item.codigo_familia + ' - ' + item.nome_empreendimento}</strong>
                            <br />
                            <small className="text-muted">{item.nome_usuario}</small>
                          </div>
                          <Button
                            size="sm"
                            variant="outline-danger"
                            onClick={function () { handleExcluirClick(item.codigo); }}
                          >
                            <FaTrash />
                          </Button>
                        </div>
                        <div style={{ fontSize: '0.85rem' }}>
                          <span className="text-muted">Incluído por: </span>{item.incluido_por}
                          <span className="mx-2">|</span>
                          {item.data_inclusao ? moment(item.data_inclusao).format('DD/MM/YYYY HH:mm') : '-'}
                        </div>
                      </Card.Body>
                    </Card>
                  );
                })}
              </div>

              {/* Paginação */}
              {porPagina > 0 && totalPaginas > 1 && (
                <div className="d-flex justify-content-between align-items-center px-3 py-2" style={{ borderTop: '1px solid #dee2e6' }}>
                  <small className="text-muted">
                    Exibindo {((paginaAtual - 1) * porPagina) + 1} a {Math.min(paginaAtual * porPagina, totalRegistros)} de {totalRegistros}
                  </small>
                  <div>
                    <Button
                      size="sm"
                      variant="outline-secondary"
                      className="mr-1"
                      disabled={paginaAtual === 1}
                      onClick={function () { setPaginaAtual(paginaAtual - 1); }}
                    >
                      Anterior
                    </Button>
                    {gerarNumerosPaginas().map(function (num) {
                      return (
                        <Button
                          key={num}
                          size="sm"
                          variant={num === paginaAtual ? 'primary' : 'outline-secondary'}
                          className="mr-1"
                          onClick={function () { setPaginaAtual(num); }}
                        >
                          {num}
                        </Button>
                      );
                    })}
                    <Button
                      size="sm"
                      variant="outline-secondary"
                      disabled={paginaAtual === totalPaginas}
                      onClick={function () { setPaginaAtual(paginaAtual + 1); }}
                    >
                      Próximo
                    </Button>
                  </div>
                </div>
              )}
            </>
          )}
        </Card.Body>
      </Card>

      {/* Modal Confirmação Exclusão */}
      <Modal show={confirmacao.show} onHide={function () { handleConfirmarExclusao(false); }} centered size="sm">
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: '1rem' }}>Confirmar Exclusão</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Deseja excluir este vínculo?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" size="sm" onClick={function () { handleConfirmarExclusao(false); }}>Cancelar</Button>
          <Button variant="danger" size="sm" onClick={function () { handleConfirmarExclusao(true); }}>Excluir</Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default RestringirAcesso;
